unit uDirect;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Menus, WEBLib.StdCtrls, WEBLib.REST, WEBLib.ExtCtrls;

type
  TForm1 = class(TForm)
    butBestellen: TButton;
    WebLabel1: TLabel;
    lblPreis: TLabel;
    WebHTTPRequest1: THTTPRequest;
    WebLabel2: TLabel;
    edtAdr1: TEdit;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    edtAdr2: TEdit;
    edtAsp: TEdit;
    edtOrt: TEdit;
    edtPLZ: TEdit;
    WebLabel7: TLabel;
    edtStrasse: TEdit;
    WebLabel8: TLabel;
    edtKNR: TEdit;
    WebLabel9: TLabel;
    edtMailRg: TEdit;
    WebLabel10: TLabel;
    lblHint: TLabel;
    WebLabel11: TLabel;
    edtLizenz: TEdit;
    edtBem: TEdit;
    WebLabel12: TLabel;
    edtMailZugang: TEdit;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    edtLand: TEdit;
    WebLabel16: TLabel;
    edtUstID: TEdit;
    rdPaketwahl: TRadioGroup;
    WebLabel13: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebLabel19: TLabel;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebLabel25: TLabel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebLabel28: TLabel;
    WebLabel29: TLabel;
    WebLinkLabel1: TLinkLabel;
    procedure butBestellenClick(Sender: TObject);
    procedure chkAboVorhandenClick(Sender: TObject);
    procedure Form1Show(Sender: TObject);
    procedure WebRadioGroup1Change(Sender: TObject);
    procedure WebRadioGroup2Change(Sender: TObject);
    procedure rdPaketwahlChange(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    procedure CheckOptionen();
    procedure SendeMail(pars: string);
  protected procedure LoadDFMValues; override; end;

var
  Form1: TForm1;

implementation

{$R *.dfm}


var  
  preis: integer;
  bolAboVorhanden, bolUmstieg, bolErweiterteLizenz : boolean;


function mybtoa(s: string): string;
// haut alles raus, was nicht ascii ist
var  
  rets: string;
  i : integer;
  c : char;
begin
  rets:='';
  for i:=1 to length(s) do
    begin
      c:=s[i];
      if ord(c)<=255 then
        rets:=rets+c;
    end;
  result:=window.btoa(rets);
end;



procedure TForm1.rdPaketwahlChange(Sender: TObject);
begin
  CheckOptionen();
end;

procedure TForm1.SendeMail(pars: string);
var  
  s0, s0a, s0ae, s1, s1b, s2, s3, s4, s5, s5a, s6, s7, s8, s9, s10, s11, strCoded : string;
  sxx : string;
begin
  sxx:=pars;
  s0:=mybtoa('PREIS: '+sxx);   // Preis in EUR
  
  // Bestellcode:
  s0a:='';
  s0a:=rdPaketwahl.Items[rdPaketwahl.ItemIndex];
  s0ae:=mybtoa('PROD: '+s0a);

  s1:=mybtoa('LIZ: '+edtLizenz.Text);
  
  s1b:=mybtoa('MAILZUG: '+edtMailZugang.Text);

  s2:=mybtoa('KNR: '+edtKNR.Text);
  s3:=mybtoa('ADR1: '+edtAdr1.Text);
  s4:=mybtoa('ADR2: '+edtAdr2.Text);
  s5:=mybtoa('ASP: '+edtAsp.Text);
  s5a:=mybtoa('STR: '+edtStrasse.Text);
  s6:=mybtoa('PLZ: '+edtPLZ.Text);
  s7:=mybtoa('ORT: '+edtOrt.Text);
  s8:=mybtoa('LAND: '+edtLand.Text);
  s9:=mybtoa('USTID: '+edtUstID.Text);
  s10:=mybtoa('MAILRG: '+edtMailRg.Text);
  s11:=mybtoa('BEM: '+edtBem.Text);

  strCoded:=s0+'#'+s0ae+'#'+s1+'#'+s1b+'#'+s2+'#'+s3+'#'+s4+'#'+s5+'#'+s5a+'#'+s6+'#'+s7+'#'+s8+'#'+s9+'#'+s10+'#'+s11;

  WebHTTPRequest1.URL:='https://budenberg-app.de/scripts/sendmailmain.php';
  WebHTTPRequest1.PostData:='BB20SENDMAIL:'+strCoded;
  WebHTTPRequest1.Execute();
end;


procedure TForm1.WebRadioGroup2Change(Sender: TObject);
begin
  CheckOptionen();
end;

procedure TForm1.WebRadioGroup1Change(Sender: TObject);
begin
  CheckOptionen();
end;

procedure TForm1.CheckOptionen();
begin
  // Preis berechnen:
  if rdPaketwahl.ItemIndex=5 then
    preis:=20
  else
    preis:=10;

  // Anzeigen:
  lblPreis.Caption:='Preis (incl. Mwst.) BUDENBERG Web Einzelplatz wie oben ausgewählt: ';
  weblabel10.Caption:=preis.ToString+',- EUR pro Jahr';
end;

procedure TForm1.Form1Show(Sender: TObject);
begin
  CheckOptionen(); 
end;

procedure TForm1.chkAboVorhandenClick(Sender: TObject);
begin
  CheckOptionen();
end;

procedure TForm1.butBestellenClick(Sender: TObject);
begin
  // hiermit wird die Bestellung abgesandt

  // Checken:
 if pos('@', edtMailZugang.Text)=0 then
    begin
      lblHint.Caption:='Keine gültige Mail-Adresse für Zugangsdaten!'
    end
  else if (trim(edtUstID.Text)<>'') and (trim(edtLand.Text)='') then
    lblhint.Caption:='Umsatzsteuer-ID --> Land fehlt!'
  else if (trim(edtAdr1.Text)='') or (trim(edtOrt.Text)='') or (trim(edtStrasse.Text)='')then
    lblhint.Caption:='Rechnungsanschrift bitte angeben.'
  else
    begin
      lblHint.Caption:='';
      SendeMail(inttostr(preis));
      // und Hinweis:
      lblHint.font.Color:=clBlue;
      lblHint.Caption:='Vielen Dank für Ihre Bestellung!';
      butBestellen.Visible:=FALSE;
      ShowMessage('Vielen Dank für die Bestellung. Nach Prüfung der Angaben erhalten Sie die Zugangsdaten und die Rechnung an die jeweils angegebene Mail-Adressen gesandt.');
    end;
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  butBestellen := TButton.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  lblPreis := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  edtAdr1 := TEdit.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  edtAdr2 := TEdit.Create(Self);
  edtAsp := TEdit.Create(Self);
  edtOrt := TEdit.Create(Self);
  edtPLZ := TEdit.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  edtStrasse := TEdit.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  edtKNR := TEdit.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  edtMailRg := TEdit.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  lblHint := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  edtLizenz := TEdit.Create(Self);
  edtBem := TEdit.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  edtMailZugang := TEdit.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  edtLand := TEdit.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  edtUstID := TEdit.Create(Self);
  rdPaketwahl := TRadioGroup.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebLabel26 := TLabel.Create(Self);
  WebLabel27 := TLabel.Create(Self);
  WebLabel28 := TLabel.Create(Self);
  WebLabel29 := TLabel.Create(Self);
  WebLinkLabel1 := TLinkLabel.Create(Self);
  WebHTTPRequest1 := THTTPRequest.Create(Self);

  butBestellen.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  lblPreis.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  edtAdr1.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  edtAdr2.BeforeLoadDFMValues;
  edtAsp.BeforeLoadDFMValues;
  edtOrt.BeforeLoadDFMValues;
  edtPLZ.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  edtStrasse.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  edtKNR.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  edtMailRg.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  lblHint.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  edtLizenz.BeforeLoadDFMValues;
  edtBem.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  edtMailZugang.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  edtLand.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  edtUstID.BeforeLoadDFMValues;
  rdPaketwahl.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLinkLabel1.BeforeLoadDFMValues;
  WebHTTPRequest1.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Color := clWhite;
    Font.Charset := ANSI_CHARSET;
    Font.Color := clBlack;
    Font.Height := -11;
    Font.Name := 'Arial';
    Font.Size := 8;
    Font.Style := [];
    FormContainer := 'body';
    FormStyle := fsNormal;
    Height := 1040;
    Left := 0;
    SetEvent(Self, 'OnShow', 'Form1Show');
    TabOrder := 0;
    Top := 0;
    Width := 640;
    butBestellen.SetParentComponent(Self);
    butBestellen.Name := 'butBestellen';
    butBestellen.Caption := 'Jetzt kostenpflichtig buchen!';
    butBestellen.Color := clNone;
    butBestellen.Font.Charset := ANSI_CHARSET;
    butBestellen.Font.Color := clBlack;
    butBestellen.Font.Height := -11;
    butBestellen.Font.Name := 'Arial';
    butBestellen.Font.Size := 8;
    butBestellen.Font.Style := [];
    butBestellen.Height := 40;
    butBestellen.Left := 32;
    SetEvent(butBestellen, Self, 'OnClick', 'butBestellenClick');
    butBestellen.Role := 'button';
    butBestellen.TabOrder := 0;
    butBestellen.Top := 928;
    butBestellen.Width := 200;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Buchung von BUDENBERG Web - Einzelplatzlizenzen';
    WebLabel1.Font.Charset := ANSI_CHARSET;
    WebLabel1.Font.Color := clBlack;
    WebLabel1.Font.Height := -11;
    WebLabel1.Font.Name := 'Arial';
    WebLabel1.Font.Size := 12;
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.Height := 26;
    WebLabel1.Left := 27;
    WebLabel1.ParentFont := False;
    WebLabel1.Top := 9;
    WebLabel1.Width := 506;
    lblPreis.SetParentComponent(Self);
    lblPreis.Name := 'lblPreis';
    lblPreis.AutoSize := False;
    lblPreis.Caption := 'Preisberechnung';
    lblPreis.Font.Charset := ANSI_CHARSET;
    lblPreis.Font.Color := clBlack;
    lblPreis.Font.Height := -11;
    lblPreis.Font.Name := 'Arial';
    lblPreis.Font.Size := 10;
    lblPreis.Font.Style := [fsBold];
    lblPreis.Height := 40;
    lblPreis.Left := 25;
    lblPreis.ParentFont := False;
    lblPreis.Top := 248;
    lblPreis.Width := 272;
    lblPreis.WordWrap := True;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Caption := 'Rechnungsanschrift:';
    WebLabel2.Font.Charset := ANSI_CHARSET;
    WebLabel2.Font.Color := clBlack;
    WebLabel2.Font.Height := -11;
    WebLabel2.Font.Name := 'Arial';
    WebLabel2.Font.Size := 10;
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.Height := 15;
    WebLabel2.Left := 28;
    WebLabel2.ParentFont := False;
    WebLabel2.Top := 480;
    WebLabel2.Width := 133;
    edtAdr1.SetParentComponent(Self);
    edtAdr1.Name := 'edtAdr1';
    edtAdr1.Alignment := taLeftJustify;
    edtAdr1.Color := clWindow;
    edtAdr1.Font.Charset := ANSI_CHARSET;
    edtAdr1.Font.Color := clBlack;
    edtAdr1.Font.Height := -11;
    edtAdr1.Font.Name := 'Arial';
    edtAdr1.Font.Size := 10;
    edtAdr1.Font.Style := [];
    edtAdr1.Height := 24;
    edtAdr1.HideSelection := False;
    edtAdr1.Hint := 'Name der Schule/Einrichtung';
    edtAdr1.Left := 238;
    edtAdr1.ParentFont := False;
    edtAdr1.ShowFocus := True;
    edtAdr1.TabOrder := 6;
    edtAdr1.Top := 512;
    edtAdr1.Width := 368;
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Caption := 'Name, Vorname oder Firma';
    WebLabel3.Font.Charset := ANSI_CHARSET;
    WebLabel3.Font.Color := clBlack;
    WebLabel3.Font.Height := -11;
    WebLabel3.Font.Name := 'Arial';
    WebLabel3.Font.Size := 10;
    WebLabel3.Font.Style := [];
    WebLabel3.Height := 15;
    WebLabel3.Left := 29;
    WebLabel3.ParentFont := False;
    WebLabel3.Top := 512;
    WebLabel3.Width := 164;
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Caption := 'Zusatz';
    WebLabel4.Font.Charset := ANSI_CHARSET;
    WebLabel4.Font.Color := clBlack;
    WebLabel4.Font.Height := -11;
    WebLabel4.Font.Name := 'Arial';
    WebLabel4.Font.Size := 10;
    WebLabel4.Font.Style := [];
    WebLabel4.Height := 15;
    WebLabel4.Left := 30;
    WebLabel4.ParentFont := False;
    WebLabel4.Top := 549;
    WebLabel4.Width := 40;
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.AutoSize := False;
    WebLabel5.Caption := 'Straße und Hausnr.';
    WebLabel5.Font.Charset := ANSI_CHARSET;
    WebLabel5.Font.Color := clBlack;
    WebLabel5.Font.Height := -11;
    WebLabel5.Font.Name := 'Arial';
    WebLabel5.Font.Size := 10;
    WebLabel5.Font.Style := [];
    WebLabel5.Height := 24;
    WebLabel5.Left := 29;
    WebLabel5.ParentFont := False;
    WebLabel5.Top := 627;
    WebLabel5.Width := 176;
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Caption := 'PLZ, Ort';
    WebLabel6.Font.Charset := ANSI_CHARSET;
    WebLabel6.Font.Color := clBlack;
    WebLabel6.Font.Height := -11;
    WebLabel6.Font.Name := 'Arial';
    WebLabel6.Font.Size := 10;
    WebLabel6.Font.Style := [];
    WebLabel6.Height := 15;
    WebLabel6.Left := 29;
    WebLabel6.ParentFont := False;
    WebLabel6.Top := 664;
    WebLabel6.Width := 50;
    edtAdr2.SetParentComponent(Self);
    edtAdr2.Name := 'edtAdr2';
    edtAdr2.Alignment := taLeftJustify;
    edtAdr2.Color := clWindow;
    edtAdr2.Font.Charset := ANSI_CHARSET;
    edtAdr2.Font.Color := clBlack;
    edtAdr2.Font.Height := -11;
    edtAdr2.Font.Name := 'Arial';
    edtAdr2.Font.Size := 10;
    edtAdr2.Font.Style := [];
    edtAdr2.Height := 24;
    edtAdr2.HideSelection := False;
    edtAdr2.Hint := 'Name der Schule/Einrichtung';
    edtAdr2.Left := 238;
    edtAdr2.ParentFont := False;
    edtAdr2.ShowFocus := True;
    edtAdr2.TabOrder := 7;
    edtAdr2.Top := 549;
    edtAdr2.Width := 368;
    edtAsp.SetParentComponent(Self);
    edtAsp.Name := 'edtAsp';
    edtAsp.Alignment := taLeftJustify;
    edtAsp.Color := clWindow;
    edtAsp.Font.Charset := ANSI_CHARSET;
    edtAsp.Font.Color := clBlack;
    edtAsp.Font.Height := -11;
    edtAsp.Font.Name := 'Arial';
    edtAsp.Font.Size := 10;
    edtAsp.Font.Style := [];
    edtAsp.Height := 24;
    edtAsp.HideSelection := False;
    edtAsp.Hint := 'Name der Schule/Einrichtung';
    edtAsp.Left := 238;
    edtAsp.ParentFont := False;
    edtAsp.ShowFocus := True;
    edtAsp.TabOrder := 8;
    edtAsp.Top := 587;
    edtAsp.Width := 368;
    edtOrt.SetParentComponent(Self);
    edtOrt.Name := 'edtOrt';
    edtOrt.Alignment := taLeftJustify;
    edtOrt.Color := clWindow;
    edtOrt.Font.Charset := ANSI_CHARSET;
    edtOrt.Font.Color := clBlack;
    edtOrt.Font.Height := -11;
    edtOrt.Font.Name := 'Arial';
    edtOrt.Font.Size := 10;
    edtOrt.Font.Style := [];
    edtOrt.Height := 24;
    edtOrt.HideSelection := False;
    edtOrt.Hint := 'Name der Schule/Einrichtung';
    edtOrt.Left := 238;
    edtOrt.ParentFont := False;
    edtOrt.ShowFocus := True;
    edtOrt.TabOrder := 11;
    edtOrt.Top := 665;
    edtOrt.Width := 368;
    edtPLZ.SetParentComponent(Self);
    edtPLZ.Name := 'edtPLZ';
    edtPLZ.Alignment := taLeftJustify;
    edtPLZ.Color := clWindow;
    edtPLZ.Font.Charset := ANSI_CHARSET;
    edtPLZ.Font.Color := clBlack;
    edtPLZ.Font.Height := -11;
    edtPLZ.Font.Name := 'Arial';
    edtPLZ.Font.Size := 10;
    edtPLZ.Font.Style := [];
    edtPLZ.Height := 24;
    edtPLZ.HideSelection := False;
    edtPLZ.Left := 110;
    edtPLZ.ParentFont := False;
    edtPLZ.ShowFocus := True;
    edtPLZ.TabOrder := 10;
    edtPLZ.Top := 665;
    edtPLZ.Width := 118;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Caption := 'gegebenenfalls Ansprechpartner';
    WebLabel7.Font.Charset := ANSI_CHARSET;
    WebLabel7.Font.Color := clBlack;
    WebLabel7.Font.Height := -11;
    WebLabel7.Font.Name := 'Arial';
    WebLabel7.Font.Size := 10;
    WebLabel7.Font.Style := [];
    WebLabel7.Height := 15;
    WebLabel7.Left := 29;
    WebLabel7.ParentFont := False;
    WebLabel7.Top := 587;
    WebLabel7.Width := 192;
    edtStrasse.SetParentComponent(Self);
    edtStrasse.Name := 'edtStrasse';
    edtStrasse.Alignment := taLeftJustify;
    edtStrasse.Color := clWindow;
    edtStrasse.Font.Charset := ANSI_CHARSET;
    edtStrasse.Font.Color := clBlack;
    edtStrasse.Font.Height := -11;
    edtStrasse.Font.Name := 'Arial';
    edtStrasse.Font.Size := 10;
    edtStrasse.Font.Style := [];
    edtStrasse.Height := 24;
    edtStrasse.HideSelection := False;
    edtStrasse.Hint := 'Name der Schule/Einrichtung';
    edtStrasse.Left := 238;
    edtStrasse.ParentFont := False;
    edtStrasse.ShowFocus := True;
    edtStrasse.TabOrder := 9;
    edtStrasse.Top := 627;
    edtStrasse.Width := 368;
    WebLabel8.SetParentComponent(Self);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Caption := 'Kundennr. (falls bekannt)';
    WebLabel8.Font.Charset := ANSI_CHARSET;
    WebLabel8.Font.Color := clBlack;
    WebLabel8.Font.Height := -11;
    WebLabel8.Font.Name := 'Arial';
    WebLabel8.Font.Size := 10;
    WebLabel8.Font.Style := [];
    WebLabel8.Height := 15;
    WebLabel8.Left := 294;
    WebLabel8.ParentFont := False;
    WebLabel8.Top := 480;
    WebLabel8.Width := 148;
    edtKNR.SetParentComponent(Self);
    edtKNR.Name := 'edtKNR';
    edtKNR.Alignment := taLeftJustify;
    edtKNR.Color := clWindow;
    edtKNR.Font.Charset := ANSI_CHARSET;
    edtKNR.Font.Color := clBlack;
    edtKNR.Font.Height := -11;
    edtKNR.Font.Name := 'Arial';
    edtKNR.Font.Size := 10;
    edtKNR.Font.Style := [];
    edtKNR.Height := 32;
    edtKNR.HideSelection := False;
    edtKNR.Left := 446;
    edtKNR.ParentFont := False;
    edtKNR.ShowFocus := True;
    edtKNR.TabOrder := 5;
    edtKNR.Top := 471;
    edtKNR.Width := 160;
    WebLabel9.SetParentComponent(Self);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.AutoSize := False;
    WebLabel9.Caption := 'E-Mail für Rechnung (falls abw. von oben)';
    WebLabel9.Font.Charset := ANSI_CHARSET;
    WebLabel9.Font.Color := clBlack;
    WebLabel9.Font.Height := -11;
    WebLabel9.Font.Name := 'Arial';
    WebLabel9.Font.Size := 10;
    WebLabel9.Font.Style := [];
    WebLabel9.Height := 40;
    WebLabel9.Left := 30;
    WebLabel9.ParentFont := False;
    WebLabel9.Top := 768;
    WebLabel9.Width := 136;
    WebLabel9.WordWrap := True;
    edtMailRg.SetParentComponent(Self);
    edtMailRg.Name := 'edtMailRg';
    edtMailRg.Alignment := taLeftJustify;
    edtMailRg.Color := clWindow;
    edtMailRg.Font.Charset := ANSI_CHARSET;
    edtMailRg.Font.Color := clBlack;
    edtMailRg.Font.Height := -11;
    edtMailRg.Font.Name := 'Arial';
    edtMailRg.Font.Size := 10;
    edtMailRg.Font.Style := [];
    edtMailRg.Height := 24;
    edtMailRg.HideSelection := False;
    edtMailRg.Hint := 'Name der Schule/Einrichtung';
    edtMailRg.Left := 182;
    edtMailRg.ParentFont := False;
    edtMailRg.ShowFocus := True;
    edtMailRg.TabOrder := 14;
    edtMailRg.Top := 784;
    edtMailRg.Width := 424;
    WebLabel10.SetParentComponent(Self);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Alignment := taRightJustify;
    WebLabel10.AutoSize := False;
    WebLabel10.Caption := 'WebLabel10';
    WebLabel10.Font.Charset := ANSI_CHARSET;
    WebLabel10.Font.Color := clBlue;
    WebLabel10.Font.Height := -11;
    WebLabel10.Font.Name := 'Arial';
    WebLabel10.Font.Size := 11;
    WebLabel10.Font.Style := [fsBold];
    WebLabel10.Height := 40;
    WebLabel10.Left := 454;
    WebLabel10.ParentFont := False;
    WebLabel10.Top := 248;
    WebLabel10.Width := 136;
    lblHint.SetParentComponent(Self);
    lblHint.Name := 'lblHint';
    lblHint.AutoSize := False;
    lblHint.Font.Charset := ANSI_CHARSET;
    lblHint.Font.Color := clRed;
    lblHint.Font.Height := -11;
    lblHint.Font.Name := 'Arial';
    lblHint.Font.Size := 12;
    lblHint.Font.Style := [];
    lblHint.Height := 32;
    lblHint.Left := 246;
    lblHint.ParentFont := False;
    lblHint.Top := 928;
    lblHint.Width := 360;
    WebLabel11.SetParentComponent(Self);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.AutoSize := False;
    WebLabel11.Caption := 'Lizenznehmer (falls abweichend von Besteller)';
    WebLabel11.Font.Charset := ANSI_CHARSET;
    WebLabel11.Font.Color := clBlack;
    WebLabel11.Font.Height := -11;
    WebLabel11.Font.Name := 'Arial';
    WebLabel11.Font.Size := 10;
    WebLabel11.Font.Style := [fsBold];
    WebLabel11.Height := 40;
    WebLabel11.Left := 32;
    WebLabel11.ParentFont := False;
    WebLabel11.Top := 336;
    WebLabel11.Width := 194;
    WebLabel11.WordWrap := True;
    edtLizenz.SetParentComponent(Self);
    edtLizenz.Name := 'edtLizenz';
    edtLizenz.Alignment := taLeftJustify;
    edtLizenz.Color := clWindow;
    edtLizenz.Font.Charset := ANSI_CHARSET;
    edtLizenz.Font.Color := clBlack;
    edtLizenz.Font.Height := -11;
    edtLizenz.Font.Name := 'Arial';
    edtLizenz.Font.Size := 10;
    edtLizenz.Font.Style := [];
    edtLizenz.Height := 32;
    edtLizenz.HideSelection := False;
    edtLizenz.Hint := 'kann leer bleiben, wird dann von uns gesetzt';
    edtLizenz.Left := 240;
    edtLizenz.ParentFont := False;
    edtLizenz.ShowFocus := True;
    edtLizenz.ShowHint := True;
    edtLizenz.TabOrder := 2;
    edtLizenz.Top := 336;
    edtLizenz.Width := 370;
    edtBem.SetParentComponent(Self);
    edtBem.Name := 'edtBem';
    edtBem.Alignment := taLeftJustify;
    edtBem.Color := clWindow;
    edtBem.Font.Charset := ANSI_CHARSET;
    edtBem.Font.Color := clBlack;
    edtBem.Font.Height := -11;
    edtBem.Font.Name := 'Arial';
    edtBem.Font.Size := 10;
    edtBem.Font.Style := [];
    edtBem.Height := 43;
    edtBem.HideSelection := False;
    edtBem.Left := 110;
    edtBem.ParentFont := False;
    edtBem.ShowFocus := True;
    edtBem.TabOrder := 15;
    edtBem.Top := 827;
    edtBem.Width := 496;
    WebLabel12.SetParentComponent(Self);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.AutoSize := False;
    WebLabel12.Caption := 'Bemerkung';
    WebLabel12.Font.Charset := ANSI_CHARSET;
    WebLabel12.Font.Color := clBlack;
    WebLabel12.Font.Height := -11;
    WebLabel12.Font.Name := 'Arial';
    WebLabel12.Font.Size := 10;
    WebLabel12.Font.Style := [];
    WebLabel12.Height := 43;
    WebLabel12.Left := 30;
    WebLabel12.ParentFont := False;
    WebLabel12.Top := 827;
    WebLabel12.Width := 68;
    edtMailZugang.SetParentComponent(Self);
    edtMailZugang.Name := 'edtMailZugang';
    edtMailZugang.Alignment := taLeftJustify;
    edtMailZugang.Color := clWindow;
    edtMailZugang.Font.Charset := ANSI_CHARSET;
    edtMailZugang.Font.Color := clBlack;
    edtMailZugang.Font.Height := -11;
    edtMailZugang.Font.Name := 'Arial';
    edtMailZugang.Font.Size := 10;
    edtMailZugang.Font.Style := [];
    edtMailZugang.Height := 32;
    edtMailZugang.HideSelection := False;
    edtMailZugang.Hint := 'Hierhin senden wir die Zugangsdaten.';
    edtMailZugang.Left := 240;
    edtMailZugang.ParentFont := False;
    edtMailZugang.ShowFocus := True;
    edtMailZugang.ShowHint := True;
    edtMailZugang.TabOrder := 4;
    edtMailZugang.Top := 392;
    edtMailZugang.Width := 368;
    WebLabel14.SetParentComponent(Self);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.AutoSize := False;
    WebLabel14.Caption := 'E-Mail-Adresse für Zugangsdaten';
    WebLabel14.Font.Charset := ANSI_CHARSET;
    WebLabel14.Font.Color := clBlack;
    WebLabel14.Font.Height := -11;
    WebLabel14.Font.Name := 'Arial';
    WebLabel14.Font.Size := 10;
    WebLabel14.Font.Style := [fsBold];
    WebLabel14.Height := 40;
    WebLabel14.Left := 32;
    WebLabel14.ParentFont := False;
    WebLabel14.Top := 392;
    WebLabel14.Width := 168;
    WebLabel14.WordWrap := True;
    WebLabel15.SetParentComponent(Self);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.AutoSize := False;
    WebLabel15.Caption := 'Land (falls nicht Deutschland)';
    WebLabel15.Font.Charset := ANSI_CHARSET;
    WebLabel15.Font.Color := clBlack;
    WebLabel15.Font.Height := -11;
    WebLabel15.Font.Name := 'Arial';
    WebLabel15.Font.Size := 10;
    WebLabel15.Font.Style := [];
    WebLabel15.Height := 24;
    WebLabel15.Left := 29;
    WebLabel15.ParentFont := False;
    WebLabel15.Top := 696;
    WebLabel15.Width := 184;
    edtLand.SetParentComponent(Self);
    edtLand.Name := 'edtLand';
    edtLand.Alignment := taLeftJustify;
    edtLand.Color := clWindow;
    edtLand.Font.Charset := ANSI_CHARSET;
    edtLand.Font.Color := clBlack;
    edtLand.Font.Height := -11;
    edtLand.Font.Name := 'Arial';
    edtLand.Font.Size := 10;
    edtLand.Font.Style := [];
    edtLand.Height := 24;
    edtLand.HideSelection := False;
    edtLand.Hint := 'Name der Schule/Einrichtung';
    edtLand.Left := 238;
    edtLand.ParentFont := False;
    edtLand.ShowFocus := True;
    edtLand.TabOrder := 12;
    edtLand.Top := 696;
    edtLand.Width := 368;
    WebLabel16.SetParentComponent(Self);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.AutoSize := False;
    WebLabel16.Caption := 'Umsatzsteuer-ID, falls vorhanden (nur in EU)';
    WebLabel16.Font.Charset := ANSI_CHARSET;
    WebLabel16.Font.Color := clBlack;
    WebLabel16.Font.Height := -11;
    WebLabel16.Font.Name := 'Arial';
    WebLabel16.Font.Size := 10;
    WebLabel16.Font.Style := [];
    WebLabel16.Height := 24;
    WebLabel16.Left := 29;
    WebLabel16.ParentFont := False;
    WebLabel16.Top := 736;
    WebLabel16.Width := 288;
    edtUstID.SetParentComponent(Self);
    edtUstID.Name := 'edtUstID';
    edtUstID.Alignment := taLeftJustify;
    edtUstID.Color := clWindow;
    edtUstID.Font.Charset := ANSI_CHARSET;
    edtUstID.Font.Color := clBlack;
    edtUstID.Font.Height := -11;
    edtUstID.Font.Name := 'Arial';
    edtUstID.Font.Size := 10;
    edtUstID.Font.Style := [];
    edtUstID.Height := 24;
    edtUstID.HideSelection := False;
    edtUstID.Hint := 'Name der Schule/Einrichtung';
    edtUstID.Left := 358;
    edtUstID.ParentFont := False;
    edtUstID.ShowFocus := True;
    edtUstID.TabOrder := 13;
    edtUstID.Top := 736;
    edtUstID.Width := 248;
    rdPaketwahl.SetParentComponent(Self);
    rdPaketwahl.Name := 'rdPaketwahl';
    rdPaketwahl.Caption := 'Paketauswahl';
    rdPaketwahl.Columns := 1;
    rdPaketwahl.Font.Charset := ANSI_CHARSET;
    rdPaketwahl.Font.Color := clBlack;
    rdPaketwahl.Font.Height := -11;
    rdPaketwahl.Font.Name := 'Arial';
    rdPaketwahl.Font.Size := 10;
    rdPaketwahl.Font.Style := [];
    rdPaketwahl.Height := 176;
    rdPaketwahl.ItemIndex := 0;
    rdPaketwahl.Items.BeginUpdate;
    try
      rdPaketwahl.Items.Clear;
      rdPaketwahl.Items.Add('Einzelplatz Klasse 1');
      rdPaketwahl.Items.Add('Einzelplatz Klasse 2');
      rdPaketwahl.Items.Add('Einzelplatz Klasse 3-6');
      rdPaketwahl.Items.Add('Einzelplatz Gesamt nur Deutsch');
      rdPaketwahl.Items.Add('Einzelplatz Gesamt nur Mathe');
      rdPaketwahl.Items.Add('Einzelplatz Gesamt');
    finally
      rdPaketwahl.Items.EndUpdate;
    end;
    rdPaketwahl.Left := 24;
    SetEvent(rdPaketwahl, Self, 'OnChange', 'rdPaketwahlChange');
    rdPaketwahl.ParentFont := False;
    rdPaketwahl.Top := 62;
    rdPaketwahl.Width := 581;
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.AutoSize := False;
    WebLabel13.Caption := 'Mathe und Deutsch Kl. 1                                    ';
    WebLabel13.Font.Charset := ANSI_CHARSET;
    WebLabel13.Font.Color := clBlack;
    WebLabel13.Font.Height := -11;
    WebLabel13.Font.Name := 'Arial';
    WebLabel13.Font.Size := 10;
    WebLabel13.Font.Style := [];
    WebLabel13.Height := 20;
    WebLabel13.Left := 252;
    WebLabel13.ParentFont := False;
    WebLabel13.Top := 85;
    WebLabel13.Width := 153;
    WebLabel17.SetParentComponent(Self);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.AutoSize := False;
    WebLabel17.Caption := 'Mathe und Deutsch Kl. 2';
    WebLabel17.Font.Charset := ANSI_CHARSET;
    WebLabel17.Font.Color := clBlack;
    WebLabel17.Font.Height := -11;
    WebLabel17.Font.Name := 'Arial';
    WebLabel17.Font.Size := 10;
    WebLabel17.Font.Style := [];
    WebLabel17.Height := 20;
    WebLabel17.Left := 252;
    WebLabel17.ParentFont := False;
    WebLabel17.Top := 110;
    WebLabel17.Width := 146;
    WebLabel18.SetParentComponent(Self);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.AutoSize := False;
    WebLabel18.Caption := 'Mathe, Deutsch, Sachunterr. Kl. 3-6';
    WebLabel18.Font.Charset := ANSI_CHARSET;
    WebLabel18.Font.Color := clBlack;
    WebLabel18.Font.Height := -11;
    WebLabel18.Font.Name := 'Arial';
    WebLabel18.Font.Size := 10;
    WebLabel18.Font.Style := [];
    WebLabel18.Height := 20;
    WebLabel18.Left := 252;
    WebLabel18.ParentFont := False;
    WebLabel18.Top := 136;
    WebLabel18.Width := 211;
    WebLabel19.SetParentComponent(Self);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.AutoSize := False;
    WebLabel19.Caption := 'ALLE Programme';
    WebLabel19.Font.Charset := ANSI_CHARSET;
    WebLabel19.Font.Color := clBlack;
    WebLabel19.Font.Height := -11;
    WebLabel19.Font.Name := 'Arial';
    WebLabel19.Font.Size := 10;
    WebLabel19.Font.Style := [];
    WebLabel19.Height := 20;
    WebLabel19.Left := 252;
    WebLabel19.ParentFont := False;
    WebLabel19.Top := 212;
    WebLabel19.Width := 106;
    WebLabel20.SetParentComponent(Self);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.AutoSize := False;
    WebLabel20.Caption := 'ALLE Matheprogramme';
    WebLabel20.Font.Charset := ANSI_CHARSET;
    WebLabel20.Font.Color := clBlack;
    WebLabel20.Font.Height := -11;
    WebLabel20.Font.Name := 'Arial';
    WebLabel20.Font.Size := 10;
    WebLabel20.Font.Style := [];
    WebLabel20.Height := 20;
    WebLabel20.Left := 252;
    WebLabel20.ParentFont := False;
    WebLabel20.Top := 188;
    WebLabel20.Width := 142;
    WebLabel21.SetParentComponent(Self);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.AutoSize := False;
    WebLabel21.Caption := 'ALLE Deutschprogramme';
    WebLabel21.Font.Charset := ANSI_CHARSET;
    WebLabel21.Font.Color := clBlack;
    WebLabel21.Font.Height := -11;
    WebLabel21.Font.Name := 'Arial';
    WebLabel21.Font.Size := 10;
    WebLabel21.Font.Style := [];
    WebLabel21.Height := 20;
    WebLabel21.Left := 252;
    WebLabel21.ParentFont := False;
    WebLabel21.Top := 162;
    WebLabel21.Width := 153;
    WebLabel22.SetParentComponent(Self);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Alignment := taRightJustify;
    WebLabel22.AutoSize := False;
    WebLabel22.Caption := '10,- EUR pro Jahr';
    WebLabel22.Font.Charset := ANSI_CHARSET;
    WebLabel22.Font.Color := clBlack;
    WebLabel22.Font.Height := -11;
    WebLabel22.Font.Name := 'Arial';
    WebLabel22.Font.Size := 10;
    WebLabel22.Font.Style := [];
    WebLabel22.Height := 15;
    WebLabel22.Left := 465;
    WebLabel22.ParentFont := False;
    WebLabel22.Top := 87;
    WebLabel22.Width := 125;
    WebLabel23.SetParentComponent(Self);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Alignment := taRightJustify;
    WebLabel23.AutoSize := False;
    WebLabel23.Caption := '10,- EUR pro Jahr';
    WebLabel23.Font.Charset := ANSI_CHARSET;
    WebLabel23.Font.Color := clBlack;
    WebLabel23.Font.Height := -11;
    WebLabel23.Font.Name := 'Arial';
    WebLabel23.Font.Size := 10;
    WebLabel23.Font.Style := [];
    WebLabel23.Height := 15;
    WebLabel23.Left := 465;
    WebLabel23.ParentFont := False;
    WebLabel23.Top := 110;
    WebLabel23.Width := 125;
    WebLabel24.SetParentComponent(Self);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Alignment := taRightJustify;
    WebLabel24.AutoSize := False;
    WebLabel24.Caption := '10,- EUR pro Jahr';
    WebLabel24.Font.Charset := ANSI_CHARSET;
    WebLabel24.Font.Color := clBlack;
    WebLabel24.Font.Height := -11;
    WebLabel24.Font.Name := 'Arial';
    WebLabel24.Font.Size := 10;
    WebLabel24.Font.Style := [];
    WebLabel24.Height := 15;
    WebLabel24.Left := 465;
    WebLabel24.ParentFont := False;
    WebLabel24.Top := 136;
    WebLabel24.Width := 125;
    WebLabel25.SetParentComponent(Self);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Alignment := taRightJustify;
    WebLabel25.AutoSize := False;
    WebLabel25.Caption := '10,- EUR pro Jahr';
    WebLabel25.Font.Charset := ANSI_CHARSET;
    WebLabel25.Font.Color := clBlack;
    WebLabel25.Font.Height := -11;
    WebLabel25.Font.Name := 'Arial';
    WebLabel25.Font.Size := 10;
    WebLabel25.Font.Style := [];
    WebLabel25.Height := 15;
    WebLabel25.Left := 465;
    WebLabel25.ParentFont := False;
    WebLabel25.Top := 162;
    WebLabel25.Width := 125;
    WebLabel26.SetParentComponent(Self);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Alignment := taRightJustify;
    WebLabel26.AutoSize := False;
    WebLabel26.Caption := '10,- EUR pro Jahr';
    WebLabel26.Font.Charset := ANSI_CHARSET;
    WebLabel26.Font.Color := clBlack;
    WebLabel26.Font.Height := -11;
    WebLabel26.Font.Name := 'Arial';
    WebLabel26.Font.Size := 10;
    WebLabel26.Font.Style := [];
    WebLabel26.Height := 15;
    WebLabel26.Left := 465;
    WebLabel26.ParentFont := False;
    WebLabel26.Top := 188;
    WebLabel26.Width := 125;
    WebLabel27.SetParentComponent(Self);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Alignment := taRightJustify;
    WebLabel27.AutoSize := False;
    WebLabel27.Caption := '20,- EUR pro Jahr';
    WebLabel27.Font.Charset := ANSI_CHARSET;
    WebLabel27.Font.Color := clBlack;
    WebLabel27.Font.Height := -11;
    WebLabel27.Font.Name := 'Arial';
    WebLabel27.Font.Size := 10;
    WebLabel27.Font.Style := [];
    WebLabel27.Height := 15;
    WebLabel27.Left := 465;
    WebLabel27.ParentFont := False;
    WebLabel27.Top := 212;
    WebLabel27.Width := 125;
    WebLabel28.SetParentComponent(Self);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.AutoSize := False;
    WebLabel28.Caption := 'Nach Prüfung Ihrer Angaben erhalten Sie eine Rechnung per E-Mail.';
    WebLabel28.Font.Charset := ANSI_CHARSET;
    WebLabel28.Font.Color := clBlack;
    WebLabel28.Font.Height := -11;
    WebLabel28.Font.Name := 'Arial';
    WebLabel28.Font.Size := 10;
    WebLabel28.Font.Style := [];
    WebLabel28.Height := 33;
    WebLabel28.Left := 29;
    WebLabel28.ParentFont := False;
    WebLabel28.Top := 880;
    WebLabel28.Width := 569;
    WebLabel29.SetParentComponent(Self);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.AutoSize := False;
    WebLabel29.Caption := 'Kunden außerhalb der EU: Bitte melden Sie sich bei unserem';
    WebLabel29.Font.Charset := ANSI_CHARSET;
    WebLabel29.Font.Color := clBlack;
    WebLabel29.Font.Height := -11;
    WebLabel29.Font.Name := 'Arial';
    WebLabel29.Font.Size := 12;
    WebLabel29.Font.Style := [];
    WebLabel29.Height := 24;
    WebLabel29.Left := 27;
    WebLabel29.ParentFont := False;
    WebLabel29.Top := 35;
    WebLabel29.Width := 440;
    WebLinkLabel1.SetParentComponent(Self);
    WebLinkLabel1.Name := 'WebLinkLabel1';
    WebLinkLabel1.AutoSize := False;
    WebLinkLabel1.Caption := '<a href="mailto:vertrieb@budenberg.de"> Vertrieb </a> ';
    WebLinkLabel1.Font.Charset := ANSI_CHARSET;
    WebLinkLabel1.Font.Color := clBlack;
    WebLinkLabel1.Font.Height := -11;
    WebLinkLabel1.Font.Name := 'Arial';
    WebLinkLabel1.Font.Size := 12;
    WebLinkLabel1.Font.Style := [];
    WebLinkLabel1.Height := 32;
    WebLinkLabel1.Left := 474;
    WebLinkLabel1.ParentFont := False;
    WebLinkLabel1.Top := 35;
    WebLinkLabel1.Width := 107;
    WebHTTPRequest1.SetParentComponent(Self);
    WebHTTPRequest1.Name := 'WebHTTPRequest1';
    WebHTTPRequest1.Command := httpPOST;
    WebHTTPRequest1.Left := 565;
    WebHTTPRequest1.Top := 280;
  finally
    butBestellen.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    lblPreis.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    edtAdr1.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    edtAdr2.AfterLoadDFMValues;
    edtAsp.AfterLoadDFMValues;
    edtOrt.AfterLoadDFMValues;
    edtPLZ.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    edtStrasse.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    edtKNR.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    edtMailRg.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    lblHint.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    edtLizenz.AfterLoadDFMValues;
    edtBem.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    edtMailZugang.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    edtLand.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    edtUstID.AfterLoadDFMValues;
    rdPaketwahl.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLinkLabel1.AfterLoadDFMValues;
    WebHTTPRequest1.AfterLoadDFMValues;
  end;
end;

end.                                                   